export default function TipItem({text = "", className = ""}) {
    return (
        <li className={className}>
            <p className="flex items-start text-justify leading-[171%]">
                <i className="icon-long-left-arrow text-xs ml-2 mt-1"/>
                <span>{text}</span>
            </p>
        </li>
    )
}
